const URL_SCHEME_PATTERN = /^[a-z][a-z\d+.-]*:/i;

export const getStoredFilePath = (value) => {
  if (Array.isArray(value)) {
    for (const item of value) {
      const path = getStoredFilePath(item);
      if (path) return path;
    }
    return "";
  }

  if (typeof value !== "string") return "";

  const trimmedValue = value.trim();
  if (!trimmedValue) return "";

  if (trimmedValue.startsWith("[")) {
    try {
      const parsedValue = JSON.parse(trimmedValue);
      return Array.isArray(parsedValue) ? getStoredFilePath(parsedValue) : "";
    } catch (error) {
      return "";
    }
  }

  if (URL_SCHEME_PATTERN.test(trimmedValue) || trimmedValue.startsWith("//")) {
    return trimmedValue;
  }

  return `/${trimmedValue.replace(/^\/+/, "")}`;
};

export const resolveStoredFileUrl = (value, origin = window.location.origin) => {
  const storedPath = getStoredFilePath(value);
  if (!storedPath) return "";

  if (URL_SCHEME_PATTERN.test(storedPath)) return storedPath;

  try {
    if (storedPath.startsWith("//")) {
      return new URL(storedPath, origin).toString();
    }

    return new URL(storedPath, origin).toString();
  } catch (error) {
    return "";
  }
};
